var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dir-upload-docs" },
    [
      _c("label", [_vm._v(_vm._s(_vm.$t("directory.label.documents")))]),
      _vm._v(" "),
      _vm.allowEdit
        ? _c("HkldDropzone", {
            attrs: { sourceId: _vm.currentDirectory.id || "" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("EditAttachments", {
        attrs: {
          canDelete: _vm.allowEdit,
          canEdit: _vm.allowEdit,
          sourceId: _vm.currentDirectory.id,
          showAllDeleteBtn: false,
          showDeleteBtnFunc: _vm.showDeleteBtnFunc,
          showEmptyMsg: !_vm.allowEdit,
          emptyMsg: _vm.$t("directory.msg.emptyDocHint"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }